import axios from 'axios';
import { route, api } from '@ht/lib-plural-vue';
import { fetchEventSource, EventStreamContentType } from '@microsoft/fetch-event-source';

const { getRobotToken, getDomain } = route;
const { setDeviceId: setLibDeviceId } = api;

class AuthError extends Error {}

const client = axios.create({
  baseURL: getDomain(),
});

export function setDeviceId(deviceId) {
  client.defaults.headers.common['x-ht-device'] = deviceId;
  setLibDeviceId(deviceId);
}

export async function askKnowledgeBase({ knowledgeBaseId, payload, meta }) {
  const token = getRobotToken();
  const resp = await client.post(`/api/kb/${knowledgeBaseId}/chat/robot/${token}`, {
    ...payload,
    meta,
  });

  return resp.data;
}

export async function askKnowledgeBaseStream({ knowledgeBaseId, payload, onMessage, meta }) {
  const domain = getDomain();
  const token = getRobotToken();

  let errorCount = 0;
  await fetchEventSource(`${domain}/api/kb/${knowledgeBaseId}/chat/robot/${token}`, {
    method: 'POST',
    body: JSON.stringify({
      ...payload,
      stream: true,
      meta,
    }),
    headers: {
      'Content-Type': 'application/json',
      'x-ht-device': client.defaults.headers.common['x-ht-device'],
    },
    async onopen(response) {
      if (response.ok && response.headers.get('content-type') === EventStreamContentType) {
        // everything's good
      } else if (response.status >= 400 && response.status < 500 && response.status !== 429) {
        // client-side errors are usually non-retriable:
        throw new AuthError();
      } else {
        throw new Error();
      }
    },
    onmessage(ev) {
      let parsedData;
      try {
        parsedData = JSON.parse(ev.data);
      } catch (err) {
        parsedData = ev.data;
      }
      onMessage(parsedData);
    },
    onerror(err) {
      if (err instanceof AuthError) {
        throw err; // rethrow to stop the operation
      } else if (errorCount === 3) {
        throw err;
      } else {
        errorCount += 1;
        return errorCount * 5000; // retry interval in case of error
      }
    },
  });
}

export async function rateChat({ conversationId, rating, knowledgeBaseId, sessionId }) {
  const token = getRobotToken();
  const resp = await client.post(`/api/kb/${knowledgeBaseId}/conversations/${conversationId}/rate/robot/${token}`, { rating, sessionId });
  return resp.data;
}
